import template from './modalDetailAdhesion.html';
import controller from './modalDetailAdhesion.controller';
import './modalDetailAdhesion.scss';

let modalDetailAdhesionComponent = {
  restrict: 'E',
  bindings: {
    loan: '<',
  },
  template,
  controller,
};

export default modalDetailAdhesionComponent;



// WEBPACK FOOTER //
// ./client/app/loans.module/features/myLoans/modals/modalDetailAdhesion/modalDetailAdhesion.component.js